import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type PortalProps = {
  children: React.ReactNode;
};

export const Portal = ({ children }: PortalProps) => {
  const [targetNode, setTargetNode] = useState<Element | null>(null);
  useEffect(() => {
    setTargetNode(document?.querySelector("#portal"));

    return () => setTargetNode(null);
  }, []);

  return targetNode ? createPortal(children, targetNode) : null;
};
